import { ACUITY_URL, ACUITY_NOTES_FIELD_ID } from "../mock";

// Build the Acuity embed URL with the client's details + quiz answers prefilled.
export function buildAcuityUrl({ name = "", email = "", phone = "", answers = {} } = {}) {
  if (!ACUITY_URL) return "";
  const [firstName, ...rest] = String(name).trim().split(" ");
  const lastName = rest.join(" ");
  const sep = ACUITY_URL.includes("?") ? "&" : "?";
  const paramsObj = {
    ref: "embedded_csp",
    firstName: firstName || "",
    lastName: lastName || "",
    email: email || "",
    phone: phone || "",
  };
  if (ACUITY_NOTES_FIELD_ID) {
    const notes = [
      answers.area ? `Area: ${answers.area}` : "",
      answers.results ? `Wants results: ${answers.results}` : "",
      answers.budget ? `Ready to invest: ${answers.budget}` : "",
      answers.timing ? `Timing: ${answers.timing}` : "",
    ]
      .filter(Boolean)
      .join(" | ");
    paramsObj[`field:${ACUITY_NOTES_FIELD_ID}`] = notes;
  }
  return `${ACUITY_URL}${sep}${new URLSearchParams(paramsObj).toString()}`;
}
